import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry error + performance monitoring for the web app.
 *
 * No-op when VITE_SENTRY_DSN is unset (local dev without a DSN), so
 * developers don't send noise to the shared Sentry project. The DSN is a
 * public value baked into the bundle at build time — the Dockerfile
 * promotes the VITE_SENTRY_DSN build-arg to an env var before `vite build`
 * (mirroring the VITE_GOOGLE_MAPS_* handling).
 *
 * The release is injected automatically by the Sentry Vite plugin at build
 * time (see vite.config.ts), and the plugin uploads source maps for that
 * same release so stack traces resolve to original source.
 */
export function initSentry(): void {
  // `import.meta.env` is untyped in this project's tsconfig (no
  // vite/client reference), so read it through a narrow local cast to
  // avoid the repo-wide "Property 'env' does not exist" tsc noise.
  const viteEnv = (import.meta as unknown as { env: Record<string, string | undefined> }).env;
  const dsn = viteEnv.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: viteEnv.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    // Light performance sampling — errors are the priority; keep trace
    // volume low to stay within the org's quota.
    tracesSampleRate: 0.1,
  });
}
